export enum NavigationEvent {
  LinkVisit = 'Link Visit (Navigation)',
}
